import { caaMetricsRepositoryAdapter } from '../../infra/repositories/caaMetricsRepositoryAdapter'

export function GetPatientCAAMetricsSemesterCase(
  repository: ReturnType<typeof caaMetricsRepositoryAdapter>
) {
  return async (params: {
    patientId: string
    personaName?: string
    period: number
    year: number
  }) => {
    return await repository.getPatientCAAMetricsSemester(params)
  }
}
